<section class="calendar-screen" aria-label="Calendar screen">
  <header class="calendar-header">
    <div>
      <p class="calendar-header__eyebrow">Calendar</p>
      <h2>{{ monthLabel() }}</h2>
    </div>

    <div class="calendar-controls">
      <div class="calendar-view-switch" aria-label="Calendar view selector">
        <button
          class="calendar-btn"
          type="button"
          [class.calendar-btn--active]="activeView() === 'dayGridMonth'"
          (click)="switchView('dayGridMonth')"
        >
          Month
        </button>
        <button
          class="calendar-btn"
          type="button"
          [class.calendar-btn--active]="activeView() === 'timeGridWeek'"
          (click)="switchView('timeGridWeek')"
        >
          Week
        </button>
        <button
          class="calendar-btn"
          type="button"
          [class.calendar-btn--active]="activeView() === 'timeGridDay'"
          (click)="switchView('timeGridDay')"
        >
          Day
        </button>
      </div>

      <div class="calendar-actions">
        <button class="calendar-btn" type="button" (click)="jumpToToday()">Today</button>
        <button class="calendar-icon-btn" type="button" aria-label="Previous month" (click)="showPreviousMonth()">
          <span class="material-icons">chevron_left</span>
        </button>
        <button class="calendar-icon-btn" type="button" aria-label="Next month" (click)="showNextMonth()">
          <span class="material-icons">chevron_right</span>
        </button>
      </div>
    </div>
  </header>

  <section class="calendar-body" aria-label="Calendar layout">
    <aside class="calendar-sidebar" aria-label="Calendar sidebar">
      <button type="button" class="calendar-new-btn" (click)="createEventForSelectedDate()">New event</button>

      <label class="calendar-date-picker">
        <span>Select date</span>
        <input type="date" [value]="formatSelectedDate()" (change)="onSelectedDateChange($event)" />
      </label>

      <section class="calendar-agenda" aria-label="Agenda">
        <header class="calendar-agenda__header">
          <h3>Agenda</h3>
          <p>{{ selectedDate().toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' }) }}</p>
        </header>

        @if (agendaItems().length === 0) {
          <p class="calendar-agenda__empty">No events for this day.</p>
        } @else {
          <div class="calendar-agenda__list">
            @for (item of agendaItems(); track item.id) {
              <button type="button" class="calendar-agenda__item" (click)="openAgendaEvent(item.id)">
                <strong>{{ item.title }}</strong>
                <span>{{ formatAgendaTime(item.start) }}</span>
              </button>
            }
          </div>
        }
      </section>
    </aside>

    <section class="calendar-shell" aria-label="Calendar grid">
      <full-calendar [options]="calendarOptions()" [deepChangeDetection]="true"></full-calendar>
    </section>
  </section>
</section>
